import React from 'react';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';
import { Receipt } from 'lucide-react';

const WageAdjustmentFields = ({ formData, setFormData }) => {
  return (
    <div className="space-y-4 p-4 bg-amber-500/5 rounded-lg border border-amber-500/20">
      <div className="flex items-center gap-2 mb-2">
        <Receipt className="h-4 w-4 text-amber-400" />
        <h3 className="text-sm font-medium text-amber-400">Wage Adjustment Details</h3>
      </div>
      
      <div className="space-y-2">
        <Label className="text-slate-300">Adjustment Type</Label>
        <Select 
          value={formData.adjustment_type} 
          onValueChange={(value) => setFormData({ ...formData, adjustment_type: value })}
        >
          <SelectTrigger className="bg-slate-900 border-slate-600 text-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-slate-800 border-slate-600">
            <SelectItem value="addition" className="text-white hover:bg-slate-700">Addition (Bonus, etc.)</SelectItem>
            <SelectItem value="deduction" className="text-white hover:bg-slate-700">Deduction</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label className="text-slate-300">Description *</Label>
        <Input
          value={formData.adjustment_description}
          onChange={(e) => setFormData({ ...formData, adjustment_description: e.target.value })}
          placeholder="e.g., Christmas Bonus, Tax Refund"
          className="bg-slate-900 border-slate-600 text-white placeholder:text-slate-500"
          required
        />
      </div>

      <div className="space-y-2">
        <Label className="text-amber-400">Amount (£) *</Label>
        <Input
          type="number"
          value={formData.adjustment_amount}
          onChange={(e) => setFormData({ ...formData, adjustment_amount: e.target.value })}
          placeholder="e.g., 500"
          className="bg-slate-900 border-slate-600 text-white w-32"
          min="0"
          step="0.01"
          required
        />
      </div>

      <div className="space-y-2">
        <Label className="text-slate-300">Applies to Month *</Label>
        <Input
          type="month"
          value={formData.date_left_uk?.slice(0, 7) || ''}
          onChange={(e) => setFormData({ 
            ...formData, 
            date_left_uk: e.target.value + '-01', 
            date_returned_uk: e.target.value + '-01' 
          })}
          className="bg-slate-900 border-slate-600 text-white"
          required
        />
      </div>
    </div>
  );
};

export default WageAdjustmentFields;
